class ProjectEntity {
  static data = {
    projects: [{
      key: 1,
      projectName: "Justified Code",
      projectDetailLink: null,
      status: "Completed",
      alias: null,
      shortDesc: "A sleek landing page for a tech company, showcasing software development and IT consulting services with a clean, intuitive design to drive user engagement.",
      description: "Justified Code is a sleek and modern landing page designed for a tech company specializing in software development and IT consulting services. The landing page aims to provide a comprehensive overview of the company's offerings, showcase their expertise, and drive user engagement through a clean and intuitive design.",
      liveUrl: "https://justified-code-f9ec1.firebaseapp.com/",
      gitUrl: null,
      demoUrl: null,
      imgSrc: "/images/projectImages/justifiedCode.png",
      keyFeatures: {
        "ResponsiveDesign": "The landing page is fully responsive, ensuring a seamless user experience across all devices, including desktops, tablets, and smartphones.",
        "EngagingHeroSection": "A captivating hero section with a high-quality background image and a compelling call-to-action button to capture the user's attention immediately.",
        "ServiceOverview": "Detailed sections highlighting the company's core services, including web development, mobile app development, and IT consulting, with eye-catching icons and concise descriptions.",
        "ClientTestimonials": "A dedicated section featuring testimonials from satisfied clients, adding credibility and trust to the company's brand.",
        "ContactForm": "An easy-to-use contact form for potential clients to get in touch with the company, integrated with email notifications for prompt responses.",
        "SEOOptimization": "The landing page is optimized for search engines, ensuring higher visibility and better search engine rankings.",
        "FastLoadingSpeed": "Optimized images and code to ensure fast loading times, providing a smooth and efficient user experience."
      },
      technologiesUsed: [
        "HTML5 & CSS3: For structuring and styling the landing page with modern web standards.",
        "JavaScript: For adding interactivity and enhancing the user experience.",
        "Bootstrap: For responsive design and layout, ensuring the landing page looks great on all devices.",
        "SEO Best Practices: Implemented to improve search engine rankings and drive organic traffic."
      ],
      tag: ["HTML", "CSS", "Bootstrap", "Javascript"]
    },

    /* 2 createdAt:5/15/2024, 11:35:01 AM*/
    {
      key: 2,
      projectName: "The Rashan Store",
      projectDetailLink: null,
      status: "Completed",
      alias: null,
      shortDesc: "A comprehensive online grocery store offering a seamless shopping experience with fresh groceries and household essentials delivered directly to customers' doorsteps.",
      description: "The Rashan Store is a comprehensive online grocery store designed to provide a seamless shopping experience for customers. This project was developed for a company specializing in delivering fresh groceries and household essentials directly to customers' doorsteps. The platform aims to simplify the grocery shopping process with an intuitive interface, a wide range of products, and convenient delivery options.",
      liveUrl: "https://www.rishabh-aggarwal.com/wp_projects/rash›",
      gitUrl: null,
      demoUrl: null,
      imgSrc: "/images/projectImages/RashanStore.png",
      keyFeatures: {
        UserFriendlyInterface: "A clean and intuitive design that makes it easy for customers to browse and purchase products.",
        ProductCategories: "Organized product categories, including fresh produce, dairy, bakery, beverages, and household essentials, to help customers find what they need quickly.",
        SearchAndFilter: "Advanced search and filter options to help customers locate specific products and narrow down their choices based on preferences.",
        ShoppingCart: "A robust shopping cart system that allows customers to add, remove, and update items before proceeding to checkout.",
        SecureCheckout: "A secure and streamlined checkout process with multiple payment options, including credit/debit cards, net banking, and digital wallets.",
        OrderTracking: "Real-time order tracking to keep customers informed about the status of their deliveries.",
        CustomerReviews: "A section for customer reviews and ratings to build trust and provide valuable feedback for other shoppers.",
        PromotionsAndDiscounts: "Integration of promotional banners and discount codes to attract and retain customers."
      },
      technologiesUsed: [
        "WordPress: For content management and easy updates.",
        "Elementor: For building and customizing the website layout with a drag-and-drop interface.",
        "WooCommerce: For managing the online store, products, and orders.",
        "HTML5 & CSS3: For structuring and styling the website.",
        "JavaScript: For adding interactivity and enhancing the user experience.",
        "Bootstrap: For responsive design and ensuring the website looks great on all devices."
      ],
      tag: ["Wordpress", "Elementor by WP", "Bootstrap"]
    },

    /* 3 createdAt:5/15/2024, 11:35:01 AM*/
    {
      key: 3,
      projectName: "My Market",
      projectDetailLink: null,
      status: "Completed",
      alias: null,
      shortDesc: "An all-in-one marketplace for clothing and makeup, offering a seamless shopping experience with a wide range of trendy clothes and high-quality makeup products.",
      description: "My Market is an all-in-one online marketplace designed to offer a wide range of clothing and makeup products. This project was developed for a company specializing in fashion and beauty, aiming to provide customers with a seamless shopping experience. The platform features an extensive collection of trendy clothes and high-quality makeup products, catering to diverse customer preferences and styles.",
      liveUrl: "https://www.rishabh-aggarwal.com/wp_projects/mymarket/",
      gitUrl: null,
      imgSrc: "/images/projectImages/MyMarket.png",
      demoUrl: null,
      keyFeatures: {
        UserFriendlyInterface: "A sleek and intuitive design that makes it easy for customers to browse and purchase products.",
        ProductCategories: "Well-organized categories for clothing and makeup, including sections for men, women, and kids, as well as various makeup brands and types.",
        AdvancedSearchAndFilter: "Powerful search and filter options to help customers quickly find specific products based on size, color, brand, price, and more.",
        ProductReviewsAndRatings: "Customer reviews and ratings for each product to provide valuable feedback and build trust among shoppers.",
        Wishlist: "A wishlist feature that allows customers to save their favorite items for future purchases.",
        SecureCheckout: "A secure and streamlined checkout process with multiple payment options, including credit/debit cards, net banking, and digital wallets.",
        OrderTracking: "Real-time order tracking to keep customers informed about the status of their deliveries.",
        PromotionsAndDiscounts: "Integration of promotional banners, discount codes, and seasonal sales to attract and retain customers."
      },
      technologiesUsed: [
        "React: For building a dynamic and responsive user interface.",
        "Node.js & Express: For creating a robust backend and handling server-side operations.",
        "MongoDB: For managing the product database and user information.",
        "HTML5 & CSS3: For structuring and styling the website.",
        "JavaScript: For adding interactivity and enhancing the user experience.",
        "Bootstrap: For responsive design and ensuring the website looks great on all devices."
      ],
      tag: ["Wordpress", "Elementor by WP", "Bootstrap"]
    },

    /* 4 createdAt:5/15/2024, 11:35:01 AM*/
    {
      key: 4,
      projectName: "The Travel Routes",
      projectDetailLink: null,
      status: "Completed",
      alias: null,
      shortDesc: "A comprehensive travel platform for booking packages, exploring destinations, and managing itineraries, featuring an intuitive interface and seamless booking process.", description: "A Complete Travel web Application created on WordPress. This project provides a comprehensive platform for users to book travel packages, explore destinations, and manage their travel itineraries. The application features an intuitive interface, seamless booking process, and integration with various travel service providers.",
      liveUrl: null,
      gitUrl: null,
      demoUrl: null,
      imgSrc: "/images/projectImages/no_image.png",
      keyFeatures: {
        "ResponsiveDesign": "The application is fully responsive, ensuring a seamless user experience across all devices, including desktops, tablets, and smartphones.",
        "BookingSystem": "A comprehensive booking system that allows users to book travel packages, flights, hotels, and car rentals with ease.",
        "DestinationExplorer": "An interactive destination explorer that provides detailed information about various travel destinations, including attractions, activities, and local tips.",
        "UserReviews": "A section for user reviews and ratings to provide valuable feedback and build trust among travelers.",
        "ItineraryManagement": "A feature to create and manage travel itineraries, helping users plan their trips efficiently.",
        "PaymentGatewayIntegration": "Secure payment gateway integration to facilitate online payments for bookings and other services.",
        "CustomerSupport": "24/7 customer support to assist users with their travel-related queries and issues.",
        "SEOOptimization": "The application is optimized for search engines, ensuring higher visibility and better search engine rankings."
      }, technologiesUsed: [
        "WordPress: For content management and easy updates.",
        "Elementor: For building and customizing the website layout with a drag-and-drop interface.",
        "WooCommerce: For managing the online store, products, and orders.",
        "HTML5 & CSS3: For structuring and styling the website.",
        "JavaScript: For adding interactivity and enhancing the user experience.",
        "Bootstrap: For responsive design and ensuring the website looks great on all devices."
      ],
      tag: ["Wordpress", "Elementor by WP"]
    },

    /* 5 createdAt:5/15/2024, 11:35:01 AM*/
    {
      key: 5,
      projectName: "Shree-Trends WMS",
      projectDetailLink: null,
      status: "Completed",
      alias: "WareHouse Management System",
      shortDesc: "A comprehensive platform to streamline warehouse operations with order management, real-time inventory tracking, and integration with Bulk SMS and SMTP servers for notifications.",
      description: "The Warehouse Management Application is a comprehensive platform designed to streamline warehouse operations with features to post and receive orders, handle various order requests, and integrate with Bulk SMS and SMTP servers for notifications and communications. This project aims to enhance the efficiency of warehouse management by providing real-time inventory tracking, order processing, and automated notifications. The integration with Bulk SMS and SMTP servers ensures timely updates and alerts to warehouse staff and customers regarding order statuses, inventory levels, and other critical information. The platform supports a wide range of warehouse activities, including inventory management, order fulfillment, and shipment tracking, ultimately improving operational efficiency and customer satisfaction.",
      liveUrl: "https://www.shreetrends.in/",
      gitUrl: null,
      demoUrl: null,
      imgSrc: "/images/projectImages/shreeTrends.png",
      keyFeatures: {
        inventoryManagement: "Efficiently manage and track inventory levels, including stock-in and stock-out processes, with real-time updates.",
        orderProcessing: "Streamlined order processing system that allows for quick and accurate order fulfillment, reducing errors and improving customer satisfaction.",
        realTimeTracking: "Real-time tracking of inventory and orders, providing visibility into the status of each item and order within the warehouse.",
        reportingAndAnalytics: "Comprehensive reporting and analytics tools to monitor warehouse performance, identify trends, and make data-driven decisions.",
        userRolesAndPermissions: "Role-based access control to ensure that only authorized personnel can access specific features and data.",
        integrationWithExternalSystems: "Seamless integration with other business systems, such as ERP and CRM, to ensure smooth data flow and coordination across departments.",
        barcodeScanning: "Support for barcode scanning to speed up inventory management and reduce manual entry errors.",
        automatedAlerts: "Automated alerts and notifications for low stock levels, order status changes, and other critical events."
      },
      technologiesUsed: [
        "PHP & MySQL: For building a robust backend and managing the database.",
        "HTML5 & CSS3: For structuring and styling the user interface.",
        "JavaScript & jQuery: For adding interactivity and enhancing the user experience.",
        "Bootstrap: For responsive design and ensuring the platform looks great on all devices.",
        "RESTful APIs: For integrating with external systems and enabling seamless data exchange."
      ],
      tag: [
        "HTML",
        "CSS3",
        "PHP",
        "MySQL",
        "Jquery",
        "Javascript"
      ]
    },

    /* 6 createdAt:5/15/2024, 11:35:01 AM*/
    {
      key: 6,
      projectName: "Streameo",
      projectDetailLink: null,
      status: "Completed",
      shortDesc: "A video streaming platform offering multiple quality options, subscription plans, and stream control features for an enhanced viewing experience.",
      description: "The Subscription-based Video Streaming website is a robust platform designed to provide users with a seamless video streaming experience. This project offers features such as streaming videos in three different qualities (low, medium, high), various subscription plans to cater to different user needs, and comprehensive stream control options. Users can easily subscribe to different plans, manage their subscriptions, and enjoy high-quality video content. The platform also includes user authentication, secure payment gateways, and personalized recommendations to enhance user engagement. Additionally, the integration of advanced streaming technologies ensures smooth playback and minimal buffering, providing an optimal viewing experience for users.",
      liveUrl: null,
      gitUrl: "https://github.com/cdacgroup16/streameo",
      demoUrl: null,
      imgSrc: "/images/projectImages/no_image.png",
      keyFeatures: {
        "MultipleQualityOptions": "Stream videos in multiple quality options (low, medium, high) to cater to different user preferences and internet speeds.",
        "SubscriptionPlans": "Various subscription plans to cater to different user needs, including monthly, quarterly, and yearly options.",
        "StreamControl": "Comprehensive stream control features, including play, pause, rewind, and fast-forward, to enhance the viewing experience.",
        "UserAuthentication": "Secure user authentication to ensure that only subscribed users can access premium content.",
        "PaymentGatewayIntegration": "Integration with secure payment gateways to facilitate easy and secure subscription payments.",
        "PersonalizedRecommendations": "Personalized video recommendations based on user preferences and viewing history.",
        "Watchlist": "A watchlist feature that allows users to save videos for later viewing.",
        "RealTimeAnalytics": "Real-time analytics to monitor user engagement and video performance.",
        "ContentManagement": "A robust content management system to upload, organize, and manage video content efficiently.",
        "SEOOptimization": "The platform is optimized for search engines to improve visibility and attract more users."
      }, technologiesUsed: [
        "React: For building a dynamic and responsive user interface.",
        "Node.js & Express: For creating a robust backend and handling server-side operations.",
        "MongoDB: For managing the user and video content database.",
        "HTML5 & CSS3: For structuring and styling the platform.",
        "JavaScript: For adding interactivity and enhancing the user experience.",
        "Bootstrap: For responsive design and ensuring the platform looks great on all devices.",
        "FFmpeg: For video processing and streaming.",
        "Stripe: For handling subscription payments."
      ],
      tag: ["MongoDB", "ExpressJS", "React", "NodeJS"]
    },

    /* 7 createdAt:5/15/2024, 11:35:01 AM*/
    {
      key: 7,
      projectName: "Personal Portfolio",
      shortDesc: "A personal portfolio website showcasing projects, skills, and professional details with an intuitive and visually appealing design.",
      description: "The Personal Portfolio website is a comprehensive platform designed to showcase my projects, skills, and professional details. This project aims to provide a detailed overview of my work, including project descriptions, technologies used, and live demos. The portfolio features an intuitive and visually appealing design, making it easy for visitors to navigate and explore my work. Additionally, the website includes sections for my resume, contact information, and a blog to share insights and updates. The platform is built using modern web technologies to ensure a responsive and engaging user experience.",
      liveUrl: "https://rishabhaggarwal.in",
      gitUrl: "https://github.com/rishcodelib",
      demoUrl: "https://rishabhaggarwal-bae83.web.app/home",
      imgSrc: "/images/projectImages/Portfolio.jpg",
      keyFeatures: {
        "ResponsiveDesign": "The portfolio is fully responsive, ensuring a seamless user experience across all devices, including desktops, tablets, and smartphones.",
        "ProjectShowcase": "A dedicated section to showcase various projects with detailed descriptions, technologies used, and live demos.",
        "AboutMe": "An 'About Me' section to provide a brief introduction and background information.",
        "ResumeDownload": "An option to download the resume in PDF format.",
        "ContactForm": "An easy-to-use contact form for visitors to get in touch, integrated with email notifications for prompt responses.",
        "BlogSection": "A blog section to share insights, updates, and articles related to the field.",
        "SEOOptimization": "The portfolio is optimized for search engines, ensuring higher visibility and better search engine rankings.",
        "SocialMediaLinks": "Links to various social media profiles to connect with visitors and potential employers."
      }, technologiesUsed: [
        "React: For building a dynamic and responsive user interface.",
        "Node.js & Express: For creating a robust backend and handling server-side operations.",
        "MongoDB: For managing the database of projects, blog posts, and contact form submissions.",
        "HTML5 & CSS3: For structuring and styling the portfolio.",
        "JavaScript: For adding interactivity and enhancing the user experience.",
        "Bootstrap: For responsive design and ensuring the portfolio looks great on all devices.",
        "Netlify: For deploying the portfolio and ensuring continuous delivery.",
        "SEO Best Practices: Implemented to improve search engine rankings and drive organic traffic."
      ],
      tag: ["NodeJS", "ExpressJS", "React", "MongoDB", "Bootstrap", "AWS"]
    },

    /* 8 createdAt:5/15/2024, 11:35:01 AM*/
    {
      key: 8,
      projectName: "Ecommerce-App",
      projectDetailLink: null,
      status: "Completed",
      shortDesc: "A complete e-commerce solution for customers, vendors, and distributors with product listings, secure payments, and order management.",
      description: "The E-Commerce Solution is a comprehensive platform designed to cater to the needs of customers, vendors, and distributors. This project provides a seamless shopping experience with features such as product listings, secure payment gateways, order management, and real-time inventory tracking. Vendors can easily manage their products, track sales, and handle customer inquiries, while distributors can oversee the supply chain and ensure timely deliveries. The platform also includes advanced search and filtering options, personalized recommendations, and integration with various third-party services to enhance functionality and user experience. Additionally, the E-Commerce Solution supports multiple languages and currencies, making it accessible to a global audience.", liveUrl: "https://ecommerceapp-14994.web.app/",
      gitUrl: "https://github.com/rishcodelib/Ecommerce-App-JAVA",
      imgSrc: "/images/projectImages/eCommerceApp.png",
      keyFeatures: {
        "React": " For building a dynamic and responsive user interface.",
        "Node.js & Express": "For creating a robust backend and handling server-side operations.",
        "MongoDB": "For managing the database of projects, blog posts, and contact form submissions.",
        "HTML5 & CSS3": "For structuring and styling the portfolio.",
        "JavaScript": "For adding interactivity and enhancing the user experience.",
        "Bootstrap": "For responsive design and ensuring the portfolio looks great on all devices.",
        "Netlify": "For deploying the portfolio and ensuring continuous delivery.",
        "SEO Best Practices": "Implemented to improve search engine rankings and drive organic traffic."
      }, technologiesUsed: [
        "React: For building a dynamic and responsive user interface.",
        "Node.js & Express: For creating a robust backend and handling server-side operations.",
        "MongoDB: For managing the product database and user information.",
        "HTML5 & CSS3: For structuring and styling the platform.",
        "JavaScript: For adding interactivity and enhancing the user experience.",
        "Bootstrap: For responsive design and ensuring the platform looks great on all devices.",
        "Stripe: For handling online payments.",
        "RESTful APIs: For integrating with external systems and enabling seamless data exchange."
      ],
      tag: ["JAVA", "Spring Boot", "Angular"]
    },
    {
      key: 9,
      projectName: "Bluetooth Based Remote Control Toy Car",
      projectDetailLink: null,
      status: "Completed",
      shortDesc: "A complete small .",
      description: "Bluetooth based remote control car",
      liveUrl: null,
      gitUrl: null,
      imgSrc: "/images/projectImages/no_image.png",
      keyFeatures: {
        "Fabrication": "For building a dynamic and responsive user interface.",
        "Microcontroller 8085": "For creating a robust backend and handling server-side operations.",
        "Bluetooth Reciever": "For managing the database of projects, blog posts, and contact form submissions.",
        "Bluetooth Mobile App": "For structuring and styling the portfolio."
      }, technologiesUsed: [
        "Objective C (Programming Language): For adding interactivity and enhancing the user experience."
      ],
      tag: ["Microcontroller & Architecture", "Itching", "Microcontroller 8085"]
    },
    {
      key: 10,
      projectName: "GSM Based Weather Monitoring System",
      projectDetailLink: null,
      status: "Completed",
      shortDesc: "This Project Was Made To Monitor Climatic Changes Such As Temperature, Humidity & Send Via SMS.",
      description: "This Project Was Made To Monitor Climatic Changes Such As Temperature, Humidity & Send Via SMS.",
      liveUrl: null,
      gitUrl: null,
      imgSrc: "/images/projectImages/no_image.png",
      keyFeatures: {
        "GSM Module": "For building a dynamic and responsive user interface.",
        "Microcontroller 8085": "For creating a robust backend and handling server-side operations.",
        "Adapters": "For managing the database of projects, blog posts, and contact form submissions.",
        "Printed Circuit Board": "For structuring and styling the portfolio."
      }, technologiesUsed: [
        "Objective C (Programming Language): For adding interactivity and enhancing the user experience."
      ],
      tag: ["Microcontroller & Architecture", "Itching", "Microcontroller 8085"]
    },
    {
      key: 12,
      projectName: "PICK & PLACE ROBOT ARM.",
      projectDetailLink: null,
      status: "Completed",
      shortDesc: "Small Crane Like Structure Prototype Controlled By Bluetooth, Used To Pick/Place Items.",
      description: "Small Crane Like Structure Prototype Controlled By Bluetooth, Used To Pick/Place Items.",
      liveUrl: null,
      gitUrl: null,
      imgSrc: "/images/projectImages/no_image.png",
      keyFeatures: {
        "Fabrication": "For building a dynamic and responsive user interface.",
        "Microcontroller 8085": "For creating a robust backend and handling server-side operations.",
        "Bluetooth Reciever": "For managing the database of projects, blog posts, and contact form submissions.",
        "Bluetooth Mobile App": "For structuring and styling the portfolio."
      }, technologiesUsed: [
        "Objective C (Programming Language): For adding interactivity and enhancing the user experience."
      ],
      tag: ["Microcontroller & Architecture", "Itching", "Microcontroller 8085"]
    },
    {
      key: 11,
      projectName: "HOME SECURITY SYSTEM USING ARM7 MICRO-CONTROLLER",
      projectDetailLink: null,
      status: "Completed",
      shortDesc: "Small Crane Like Structure Prototype Controlled By Bluetooth, Used To Pick/Place Items.",
      description: "Small Crane Like Structure Prototype Controlled By Bluetooth, Used To Pick/Place Items.",
      liveUrl: null,
      gitUrl: null,
      imgSrc: "/images/projectImages/no_image.png",
      keyFeatures: {
        "Fabrication": "For building a dynamic and responsive user interface.",
        "Microcontroller 8085": "For creating a robust backend and handling server-side operations.",
        "Bluetooth Reciever": "For managing the database of projects, blog posts, and contact form submissions.",
        "Bluetooth Mobile App": "For structuring and styling the portfolio."
      }, technologiesUsed: [
        "Objective C (Programming Language): For adding interactivity and enhancing the user experience."
      ],
      tag: ["Microcontroller & Architecture", "Itching", "Microcontroller 8085"]
    }
    ]
  };

  static getProjects() {
    return this.data.projects;
  }
  static getProject(key) {
    return this.data.projects.find(project => project.key === key);
  }
}

export default ProjectEntity;